var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('h2',{staticClass:"Error",style:({ paddingTop: this.hauteur })},[_vm._v("\n    Accès refusé\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }